import icSocLogoTmt from 'assets/icons/TMT/Logo/tmt_logo.svg';
import icSocBack from 'assets/images/SOC/ic_soc_back.svg';
import icSocCalendar from 'assets/images/SOC/ic_soc_calendar.svg';
import icSocClock from 'assets/images/SOC/ic_soc_clock.svg';
import imgSocHeader from 'assets/images/SOC/img_soc_header.png';
import UIHelper from 'general/helpers/UIHelper';
import useRouter from 'hooks/useRouter';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

SOCHeaderView.propTypes = {
  padding: PropTypes.number,
  windowSize: PropTypes.object,
};

function SOCHeaderView({ padding = 0, windowSize = { width: 0, height: 0 } }) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const [currentTime, setCurrentTime] = useState(moment().format('HH:mm'));
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment().format('HH:mm'));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="w-100 position-relative"
      style={{
        aspectRatio: '1920/67',
        pointerEvents: 'visible',
        backgroundImage: `url(${imgSocHeader})`,
        backgroundSize: 'contain',
      }}
    >
      {/* back button */}
      <div
        className="position-absolute h-50 d-flex align-items-center justify-content-center cursor-pointer hover-opacity-60"
        style={{
          aspectRatio: '1/1',
          left: `${padding}px`,
          top: '25%',
        }}
        onClick={() => {
          router.navigate('/');
        }}
      >
        <img src={icSocBack} alt="back-button" className="w-100 h-100" />
      </div>
      {/* logo */}
      <div
        className="position-absolute h-50 d-flex align-items-center justify-content-center"
        style={{
          aspectRatio: '51/28',
          right: `${padding}px`,
          top: '25%',
        }}
      >
        <img src={icSocLogoTmt} alt="logo-tmt" className="w-100 h-100" />
      </div>
      {/* title */}
      <div
        className="position-absolute d-flex align-items-center justify-content-center"
        style={{
          height: '80%',
          width: '21%',
          left: '50%',
          top: '10%',
          transform: 'translateX(-50%)',
        }}
      >
        <span
          className="text-uppercase w-100 text-center"
          style={UIHelper.buildFontStyle('600', `${windowSize.width * 0.014}px`, '#1EF5DF')}
        >
          Bản đồ phân bố trạm sạc
        </span>
      </div>
      {/* calendar & clock */}
      <div
        className="position-absolute h-50 d-flex align-items-center justify-content-end gap-4"
        style={{
          top: '25%',
          left: `calc(${padding}px + 5%)`,
          width: '25%',
        }}
      >
        <div
          className="d-flex align-items-center gap-1"
          style={{
            height: '70%',
          }}
        >
          <img
            src={icSocCalendar}
            alt="calendar"
            className="h-100"
            style={{ aspectRatio: '1/1' }}
          />
          <span style={UIHelper.buildFontStyle('700', `${windowSize.width * 0.009}px`, '#fff')}>
            {moment().format('DD/MM/YYYY')}
          </span>
        </div>
        <div
          className="d-flex align-items-center gap-1"
          style={{
            height: '70%',
          }}
        >
          <img src={icSocClock} alt="clock" className="h-100" style={{ aspectRatio: '1/1' }} />
          <span style={UIHelper.buildFontStyle('700', `${windowSize.width * 0.009}px`, '#fff')}>
            {currentTime}{' '}
          </span>
        </div>
      </div>
    </div>
  );
}

export default SOCHeaderView;
